import React from 'react'
import ReactDOM from 'react-dom'

import './index.styles.scss'

import App from './app'

const entryPoint = document.querySelector('#root')
ReactDOM.render(<App />, entryPoint)
